exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-69f741be] .md-checkbox-container {\n  top: 10px;\n}\n[data-v-69f741be] .md-checkbox-label {\n  opacity: 1 !important;\n  color: black !important;\n}\n[data-v-69f741be] div.md-field.no-underline:after {\n  height: 0px;\n}\n[data-v-69f741be] .md-checkbox {\n  margin-top: 0px;\n}\n.modal-container[data-v-69f741be] {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n.wide-container[data-v-69f741be] {\n  max-width: 1080px !important;\n  width: 100%;\n}\n[data-v-69f741be] .modal-body {\n  min-height: 50%;\n  overflow: hidden;\n}\n", ""]);

// exports
